module.exports = __webpack_public_path__ + "img/marker_one_yellow1.d1226475.png";